import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Register() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const [form, setForm] = useState({
    email: "",
    password: "",
    ref: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // referral from URL
  useEffect(() => {
    const ref = params.get("ref");

    if (ref) {
      setForm((p) => ({ ...p, ref }));
    }
  }, [params]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const submit = async (e) => {
    e.preventDefault();

    setError("");
    setLoading(true);

    try {
      const res = await fetch(
        "https://algoxpo.online/api/auth/register",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Registration failed");
        setLoading(false);
        return;
      }

      alert("Registration successful");

      navigate("/login");
    } catch (err) {
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      {/* background glow */}
      <div style={styles.glow1}></div>
      <div style={styles.glow2}></div>

      <div style={styles.container}>
        {/* LOGO */}
        <img src={logo} alt="logo" style={styles.logo} />

        {/* CARD */}
        <form style={styles.card} onSubmit={submit}>
          <h1 style={styles.title}>Create Your Account</h1>

          <p style={styles.subtitle}>
            Join AlgoXpo and unlock the power of algorithms.
          </p>

          {error && <div style={styles.error}>{error}</div>}

          {/* EMAIL */}
          <div style={styles.inputWrap}>
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
              value={form.email}
              onChange={handleChange}
              style={styles.input}
            />
          </div>

          {/* PASSWORD */}
          <div style={styles.inputWrap}>
            <input
              type="password"
              name="password"
              placeholder="Password"
              required
              value={form.password}
              onChange={handleChange}
              style={styles.input}
            />
          </div>

          {/* REFERRAL */}
          <div style={styles.inputWrap}>
            <input
              type="text"
              name="ref"
              placeholder="Sponsor ID (Optional)"
              value={form.ref}
              onChange={handleChange}
              style={styles.input}
            />
          </div>

          {/* TERMS */}
          <div style={styles.terms}>
            <input type="checkbox" required />

            <span>
              I agree to the{" "}
              <span style={styles.linkText}>Terms of Service</span> and{" "}
              <span style={styles.linkText}>Privacy Policy</span>
            </span>
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            disabled={loading}
            style={styles.button}
          >
            {loading ? "Creating..." : "Sign Up"}
          </button>

          {/* LOGIN */}
          <p style={styles.bottomText}>
            Already have an account?{" "}
            <Link to="/login" style={styles.loginLink}>
              Sign In
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    background:
      "radial-gradient(circle at top,#07152f 0%,#020617 55%,#000814 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    padding: "20px",
    boxSizing: "border-box",
    fontFamily: "Arial, sans-serif",
  },

  glow1: {
    position: "absolute",
    width: 400,
    height: 400,
    background: "#0ea5ff",
    filter: "blur(180px)",
    opacity: 0.18,
    top: -120,
    left: -120,
  },

  glow2: {
    position: "absolute",
    width: 350,
    height: 350,
    background: "#2563eb",
    filter: "blur(180px)",
    opacity: 0.15,
    bottom: -120,
    right: -120,
  },

  container: {
    width: "100%",
    maxWidth: 460,
    zIndex: 2,
    textAlign: "center",
  },

  logo: {
    width: "100%",
    maxWidth: 360,
    marginBottom: 20,
    filter: "drop-shadow(0 0 30px #0ea5ff)",
  },

  card: {
    width: "100%",
    background: "rgba(10,20,40,0.55)",
    backdropFilter: "blur(14px)",
    border: "1px solid rgba(14,165,255,0.25)",
    borderRadius: 24,
    padding: "35px 28px",
    boxSizing: "border-box",
    boxShadow: "0 0 40px rgba(0,140,255,0.15)",
  },

  title: {
    color: "#fff",
    fontSize: 42,
    margin: 0,
    marginBottom: 10,
    fontWeight: "700",
  },

  subtitle: {
    color: "#94a3b8",
    fontSize: 16,
    marginBottom: 28,
    lineHeight: 1.6,
  },

  error: {
    background: "rgba(220,38,38,0.2)",
    border: "1px solid rgba(239,68,68,0.4)",
    color: "#fff",
    padding: "12px",
    borderRadius: 12,
    marginBottom: 18,
    fontSize: 14,
  },

  inputWrap: {
    marginBottom: 18,
  },

  input: {
    width: "100%",
    padding: "16px 18px",
    borderRadius: 14,
    border: "1px solid rgba(255,255,255,0.1)",
    background: "rgba(255,255,255,0.05)",
    color: "#fff",
    fontSize: 16,
    outline: "none",
    boxSizing: "border-box",
  },

  terms: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    color: "#cbd5e1",
    fontSize: 14,
    marginTop: 5,
    marginBottom: 24,
    textAlign: "left",
    lineHeight: 1.5,
  },

  linkText: {
    color: "#0ea5ff",
  },

  button: {
    width: "100%",
    padding: "16px",
    borderRadius: 14,
    border: "none",
    background: "linear-gradient(90deg,#0ea5ff,#2563eb)",
    color: "#fff",
    fontSize: 18,
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 10px 25px rgba(14,165,255,0.35)",
  },

  bottomText: {
    marginTop: 24,
    color: "#cbd5e1",
    fontSize: 15,
  },

  loginLink: {
    color: "#0ea5ff",
    textDecoration: "none",
    fontWeight: "bold",
  },
};
